import { ModalV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import RingModelsModalModel, {
  type RingModelsModalModelProps,
} from './RingModelsModalModel';

export interface RingModelsModalProps {
  readonly isOpen: boolean;
  readonly models?: RingModelsModalModelProps[];
  readonly toggleModal: (isOpen: boolean) => void;
}

const DEFAULT_MODELS: RingModelsModalModelProps[] = [
  {
    description: 'charger_wizard_modal_gen4_description',
    imageSrc: '/Frame_2147221869_XBA8J0.png',
    isNew: true,
    title: 'pdp_style_oura_ring_4',
  },
  {
    description: 'charger_wizard_modal_gen3_horizon_description',
    imageSrc: '/image-mask_WF45XB.png',
    title: 'charger_wizard_modal_gen3_horizon',
  },
  {
    description: 'charger_wizard_modal_gen3_heritage_description',
    imageSrc: '/image-mask_JH7NZZ.png',
    title: 'charger_wizard_modal_gen3_heritage',
  },
];

const RingModelsModal = ({
  isOpen,
  models = DEFAULT_MODELS,
  toggleModal,
}: RingModelsModalProps): JSX.Element => {
  const t = useTranslations();

  return (
    <ModalV3
      isOpen={isOpen}
      onOpenChange={toggleModal}
      padding="small"
      rounded
      size="medium"
    >
      <div data-cy="ring-models-modal-wrapper">
        <TypographyV3 className="mb-4" Element="h2" variant="h4">
          {t('charger_wizard_modal_title')}
        </TypographyV3>
        <TypographyV3 className="mb-5 border-b-2 border-sandstone-400 pb-5">
          {t('charger_wizard_modal_subtitle')}
        </TypographyV3>
        <div className="flex flex-col justify-between lg:flex-row xl:justify-around">
          {models.map((model) => (
            <RingModelsModalModel {...model} key={model.title} />
          ))}
        </div>
      </div>
    </ModalV3>
  );
};

export default RingModelsModal;
